(() => {
  const normalize = (value) => value.toLowerCase().replace(/\s+/g, " ").trim();

  const initializeHelpCenter = (root) => {
    if (!root || root.dataset.dbHelpReady === "true") return;

    const input = root.querySelector("[data-db-help-search]");
    const clearButton = root.querySelector("[data-db-help-clear]");
    const status = root.querySelector("[data-db-help-status]");
    const emptyState = root.querySelector("[data-db-help-empty]");
    const topics = [...root.querySelectorAll("[data-db-help-topic]")];
    const items = [...root.querySelectorAll("[data-db-help-item]")];

    if (!input || !items.length) return;
    root.dataset.dbHelpReady = "true";

    items.forEach((item) => {
      item.dataset.dbHelpText = normalize(`${item.dataset.search || ""} ${item.textContent || ""}`);
    });

    const update = () => {
      const query = normalize(input.value);
      let visibleCount = 0;

      items.forEach((item) => {
        const visible = !query || item.dataset.dbHelpText.includes(query);
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      topics.forEach((topic) => {
        topic.hidden = !topic.querySelector("[data-db-help-item]:not([hidden])");
      });

      clearButton.hidden = !query;
      emptyState.hidden = visibleCount !== 0;
      status.textContent = query
        ? `${visibleCount} ${visibleCount === 1 ? "answer" : "answers"} found`
        : "";
    };

    input.addEventListener("input", update);
    clearButton.addEventListener("click", () => {
      input.value = "";
      update();
      input.focus();
    });
  };

  const initializeAll = () => {
    document.querySelectorAll("[data-db-help-center]").forEach(initializeHelpCenter);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", initializeAll);
})();
